<style>
  .sp-form-field {
    margin: 24px 0 0;
  }

  .description {
    margin: 4px 0 20px;
    color: #475467;
    font-size: 13px;
    font-style: italic;
    line-height: 1.5;
  }

  .warning {
    color: red;
  }

  mat-form-field {
    width: 100%;
  }

  .radiobuttonmargin {
    margin: 0 20px 10px 0;
  }

  .search-input-wrapper {
    padding: 8px 16px;
    display: flex;
    align-items: center;
  }

  .search-input {
    width: 100%;
    border: none;
    outline: none;
    font-size: 16px;
  }

  .search-input-wrapper:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  .payment-reciever-loading {
    opacity: 0.55;
  }

  .payment-reciever-header {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .payment-reciever-header h2 {
    margin: 0;
    color: #111827;
    font-size: 20px;
    font-weight: 700;
  }

  .payment-reciever-select-container {
    flex: 1 1 auto;
    min-width: 0;
  }

  .payment-reciever-spinner {
    display: flex;
    align-items: center;
    min-width: 24px;
  }

  .dialog-field {
    width: 100%;
    display: block;
  }

  .dialog-field-row {
    display: grid;
    grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
    gap: 16px;
    align-items: start;
  }

  .dialog-section {
    margin-top: 24px;
    padding-top: 20px;
    border: 0;
    border-top: 1px solid #dfe4ec;
    border-radius: 0;
  }

  .dialog-section h3 {
    margin: 0 0 4px;
    color: #111827;
    font-size: 17px;
    font-weight: 700;
  }

  .dialog-row {
    margin: 0 0 16px;
    padding: 0;
  }

  .dialog-field-cell {
    min-width: 0;
  }

  .payment-reciever-select-field {
    margin-bottom: 0;
  }

  .employment-fieldset {
    margin: 0 0 16px;
    padding: 0;
    border: 0;
  }

  .employment-fieldset legend {
    margin-bottom: 12px;
    color: #111827;
    font-size: 14px;
    font-weight: 700;
  }

  .employment-options {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px 28px;
  }

  .dialog-section-intro {
    margin: 0 0 20px;
    color: #59657b;
    font-size: 13px;
    line-height: 1.5;
  }

  .dialog-subsection-heading {
    margin: 0 0 10px;
    color: #111827;
    font-size: 15px;
    font-weight: 700;
  }

  .employment-fieldset .employment-options {
    flex-wrap: nowrap;
    gap: 24px;
  }

  .employment-fieldset .radiobuttonmargin {
    margin: 0 !important;
  }

  .salary-calculator-settings {
    display: grid;
    gap: 20px;
  }

  .salary-calculator-section {
    margin: 24px 0 16px;
    border: 1px solid #dfe4ec;
    border-radius: 9px;
    overflow: hidden;
  }

  .salary-calculator-trigger {
    display: flex;
    width: 100%;
    padding: 16px;
    border: 0;
    background: #ffffff;
    color: #111827;
    text-align: left;
    cursor: pointer;
  }

  .salary-calculator-trigger-content {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 4px;
  }

  .salary-calculator-trigger-title {
    font-size: 17px;
    font-weight: 700;
  }

  .salary-calculator-trigger-summary {
    color: #59657b;
    font-size: 13px;
    line-height: 1.4;
  }

  .salary-calculator-trigger mat-icon {
    margin-left: 16px;
    color: var(--sam-accent-color, #005c96);
  }

  .salary-calculator-section-content {
    padding: 0 16px 20px;
    border-top: 1px solid #eef0f5;
  }

  .salary-calculator-notice {
    margin: 16px 0 20px;
    color: #59657b;
    font-size: 13px;
    line-height: 1.5;
  }

  .salary-calculator-notice strong {
    color: #111827;
  }

  .salary-calculator-service-fee {
    margin-top: 8px;
  }

  .calculator-choice-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }

  .calculator-choice-group {
    display: flex;
    flex-direction: column;
    min-width: 0;
    padding: 16px;
    border: 1px solid #dfe4ec;
    border-radius: 9px;
    background: #fbfcfe;
  }

  .calculator-choice-group h4,
  .calculator-setting-title {
    margin: 0 0 10px;
    color: #111827;
    font-size: 14px;
    font-weight: 700;
  }

  .calculator-setting-description {
    margin: -2px 0 12px;
    color: #59657b;
    font-size: 13px;
    line-height: 1.45;
  }

  .pension-setting-row {
    max-width: 280px;
    margin-top: 16px;
  }

  .pension-mode-description {
    margin: 16px 0 12px;
  }

  .calculator-input-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }

  .calculator-base-amount {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 44px;
    padding: 10px 12px;
    border: 1px solid #dfe4ec;
    border-radius: 7px;
    background: #fbfcfe;
    color: #111827;
    font-size: 13px;
  }

  .calculator-base-amount span {
    color: #59657b;
  }

  .calculator-amount-context {
    margin: 0 0 8px;
    color: #59657b;
    font-size: 13px;
    line-height: 1.4;
  }

  .salary-calculator-settings .dialog-field {
    margin: 0;
  }

  .vacation-setting {
    padding-top: 4px;
    border-top: 1px solid #eef0f5;
  }

  .calculator-choice-group .employment-options {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    margin-top: auto;
  }

  .calculator-choice-group .employment-options mat-radio-button {
    display: inline-flex !important;
    width: auto !important;
    min-width: 0;
    margin: 0 !important;
  }

  .calculator-choice-group-disabled {
    opacity: 0.55;
  }

  :host ::ng-deep .dialog-field .mat-form-field-flex,
  :host ::ng-deep .dialog-field .mat-mdc-text-field-wrapper {
    min-height: 56px;
    padding: 0 12px !important;
    border: 1px solid #dfe4ec;
    border-radius: 7px;
    background: var(--sam-input-background, #f7f7f7);
    box-sizing: border-box;
  }

  :host ::ng-deep .dialog-field .mat-form-field-infix,
  :host ::ng-deep .dialog-field .mat-mdc-form-field-infix {
    min-height: 56px;
    padding-top: 20px;
    padding-bottom: 6px;
    border-top: 0;
  }

  :host ::ng-deep .calculator-number-field .mat-form-field-infix,
  :host ::ng-deep .calculator-number-field .mat-mdc-form-field-infix {
    padding-top: 24px;
    padding-bottom: 2px;
  }

  :host ::ng-deep .dialog-field .mat-form-field-underline,
  :host ::ng-deep .dialog-field .mdc-line-ripple::before,
  :host ::ng-deep .dialog-field .mdc-line-ripple::after {
    display: none !important;
  }

  :host ::ng-deep .dialog-field .mat-mdc-form-field-subscript-wrapper,
  :host ::ng-deep .dialog-field .mat-form-field-subscript-wrapper {
    display: none !important;
  }

  :host ::ng-deep .payment-reciever-select-field .mat-form-field-infix,
  :host ::ng-deep .payment-reciever-select-field .mat-mdc-form-field-infix {
    padding-top: 20px;
    padding-bottom: 6px;
    min-height: 52px;
  }

  :host ::ng-deep .payment-reciever-select-field .mat-select-trigger,
  :host ::ng-deep .payment-reciever-select-field .mat-mdc-select-trigger {
    margin-top: 0;
  }

  :host ::ng-deep .dialog-field textarea.mat-input-element {
    min-height: 72px;
    margin-top: 0;
    resize: vertical;
  }

  :host ::ng-deep .info {
    color: var(--sam-accent-color, #005c96) !important;
  }

  .add-reciever-button {
    flex: 0 0 48px;
    color: var(--sam-accent-color, #005c96);
  }

  .dialog-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
  }

  .dialog-actions button {
    min-width: 120px;
    height: 44px !important;
    min-height: 44px;
    margin: 0 !important;
    padding: 0 18px;
    border-radius: 999px !important;
    box-shadow: 0 3px 10px rgba(20, 36, 63, 0.1) !important;
    font-size: 14px;
    font-weight: 600;
    line-height: 44px;
    transition: box-shadow 150ms ease, transform 150ms ease;
  }

  .dialog-actions button:not(:disabled):hover {
    box-shadow: 0 5px 14px rgba(20, 36, 63, 0.13) !important;
    transform: translateY(-1px);
  }

  .dialog-actions .dialog-save-button:not(:disabled) {
    border-color: var(--sam-accent-color, #005c96) !important;
    color: #ffffff !important;
    background: var(--sam-accent-color, #005c96) !important;
  }

  .dialog-actions button:disabled {
    box-shadow: none !important;
    transform: none;
  }

  @media only screen and (max-width: 768px) {
    .dialog-field-row {
      grid-template-columns: 1fr;
      gap: 16px;
    }

    .calculator-choice-grid,
    .calculator-input-grid {
      grid-template-columns: 1fr;
    }

    .employment-fieldset .employment-options {
      flex-wrap: wrap;
    }
  }
</style>

<form name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
  <div class="col-12" style="padding:0;">
    <div class="payment-reciever-header">
      <h2>Betalmottagare</h2>
    </div>
    <div class="description">Välj vilka som ska få lön/betalning i fakturaunderlaget</div>
    <div class="d-flex align-items-center" [class.payment-reciever-loading]="isLoadingPaymentRecievers">
      <div class="payment-reciever-select-container">
        <mat-form-field floatLabel="always" class="dialog-field payment-reciever-select-field">
          <mat-label>Välj betalmottagare ({{selectedPaymentRecieverKeys.length}})</mat-label>
          <mat-select class="select-paymentreciever"
                      style="color: black;"
                      name="paymentrecievers"
                      [disabled]="isLoadingPaymentRecievers"
                      [ngModel]="selectedPaymentRecieverKeys"
                      (ngModelChange)="onPaymentRecieverSelectionChange($event)"
                      [compareWith]="comparePaymentRecieverSelection"
                      multiple
                      (openedChange)="resetSearchTerm($event)">
            <mat-select-trigger>{{ getSelectedPaymentRecieverTriggerText() }}</mat-select-trigger>

            <div class="search-input-wrapper">
              <input matInput
                     placeholder="Sök..."
                     [(ngModel)]="searchTerm"
                     (ngModelChange)="filterPaymentReceivers()"
                     autocomplete="off"
                     name="searchterm"
                     class="search-input">
            </div>

            <div class="search-input-wrapper" *ngIf="!isLoadingPaymentRecievers && filteredPaymentRecievers.length === 0" disabled>
              Inga användare hittades
            </div>

            <ng-container *ngFor="let item of filteredPaymentRecievers">
              <mat-option [value]="getPaymentRecieverSelectionValue(item)"
                          [selected]="isPaymentRecieverSelected(item)"
                          (onSelectionChange)="onPaymentRecieverOptionSelectionChange(item, $event.source.selected, $event.isUserInput)">
                {{item.FirstName}} {{item.LastName}} ({{item.PersonalNumber}})
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="payment-reciever-spinner" *ngIf="isLoadingPaymentRecievers" style="margin-left: 10px;">
        <mat-spinner diameter="18" color="accent"></mat-spinner>
      </div>

      <button type="button" mat-icon-button class="add-reciever-button" aria-label="Lägg till ny ersättningsmottagare" matTooltip="Lägg till ny ersättningsmottagare" (click)="createSalaryReciever($event)">
        <mat-icon>person_add</mat-icon>
      </button>
    </div>
  </div>

  <section class="dialog-section">
    <h3>Inställningar för valda ersättningsmottagare</h3>
    <div class="dialog-section-intro">Inställningarna gäller bara för ersättningsmottagare som väljs i listan ovan, och kan redigeras manuellt i respektive mottagares information efter att du lagt till dem.<br><br>Val som lämnas tomma redigeras manuellt för varje ersättningsmottagare i verktygets huvudvy.<br><br>Om du vill kan du ange bruttolön som underlag, antingen i grupp nedan eller per person i verktyget. Fakturabeloppet beräknas sedan per ersättningsmottagare.</div>

  <div class="dialog-subsection-heading">Gemensam information</div>
  <div class="col-12 row dialog-row">
    <mat-form-field floatLabel="always" class="dialog-field">
      <mat-label>Beskrivning</mat-label>
      <textarea matInput
                rows="3"
                [(ngModel)]="invoiceGroupTemplate.Description"
                id="message"
                name="description-quick-add"></textarea>
    </mat-form-field>
  </div>

  <fieldset class="employment-fieldset">
    <legend>Anställningsform</legend>
    <mat-radio-group class="employment-options" name="employmentType" [(ngModel)]="invoiceGroupTemplate.EmploymentTypeId">
      <mat-radio-button class="ml-2 radiobuttonmargin" [value]="2">Egenanställd <mat-icon color="accent" class="info" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Personen är egenanställd via SAMpoolen. Den egenanställda betalar själv serviceavgiften.">info</mat-icon></mat-radio-button>
      <mat-radio-button class="ml-2 radiobuttonmargin" [value]="1">Bemanning <mat-icon color="accent" class="info" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Personen är anställd av SAMgruppen på uppdrag av dig. Uppdragsgivaren betalar vår serviceavgift.">info</mat-icon></mat-radio-button>
      <mat-radio-button class="ml-2 radiobuttonmargin" [value]="3">Konsult/företagare/enskild firma <mat-icon color="accent" class="info" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Uppdragstagaren är egen företagare. Ingen serviceavgift.">info</mat-icon></mat-radio-button>
    </mat-radio-group>
  </fieldset>

  <section class="salary-calculator-section">
    <button type="button" class="salary-calculator-trigger" (click)="salaryCalculatorSettingsExpanded = !salaryCalculatorSettingsExpanded" [attr.aria-expanded]="salaryCalculatorSettingsExpanded">
      <span class="salary-calculator-trigger-content">
        <span class="salary-calculator-trigger-title">Räkna ut fakturerat belopp utifrån bruttolön</span>
      </span>
      <mat-icon>{{ salaryCalculatorSettingsExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>

    <div class="salary-calculator-section-content" *ngIf="salaryCalculatorSettingsExpanded">
      <div class="salary-calculator-notice salary-calculator-service-fee" *ngIf="invoiceGroupTemplate.EmploymentTypeId === 2 && data?.serviceFeeFactor > 0">För egenanställda dras en serviceavgift på {{ data.serviceFeeFactor * 100 | number:'1.0-2' }} % från grundbeloppet, enligt fakturans inställning.</div>

      <div class="salary-calculator-settings">
      <div class="calculator-choice-grid">
        <section class="calculator-choice-group">
          <h4>Räkna ut fakturerat belopp utifrån bruttolön</h4>
          <mat-radio-group class="employment-options" name="salaryCalculatorMode" [(ngModel)]="invoiceGroupTemplate.SalaryCalculator.mode" (ngModelChange)="onSalaryCalculatorModeChanged()">
            <mat-radio-button [value]="'gross'">Ja</mat-radio-button>
            <mat-radio-button [value]="'invoice'">Nej</mat-radio-button>
          </mat-radio-group>
        </section>

        <section class="calculator-choice-group" [class.calculator-choice-group-disabled]="invoiceGroupTemplate.SalaryCalculator.mode === 'invoice'">
          <h4>Ersättningen avser</h4>
          <mat-radio-group class="employment-options" name="salaryCalculatorType" [(ngModel)]="invoiceGroupTemplate.SalaryCalculator.salaryType" [disabled]="invoiceGroupTemplate.SalaryCalculator.mode === 'invoice'">
            <mat-radio-button [value]="'hourly'">Timlön</mat-radio-button>
            <mat-radio-button [value]="'monthly'">Klumpsumma</mat-radio-button>
          </mat-radio-group>
        </section>
      </div>

      <div class="calculator-input-grid" *ngIf="invoiceGroupTemplate.SalaryCalculator.salaryType === 'hourly'">
        <mat-form-field floatLabel="always" class="dialog-field calculator-number-field">
          <mat-label>{{ invoiceGroupTemplate.SalaryCalculator.mode === 'gross' ? 'Bruttolön per timme' : 'Fakturerat belopp per timme' }}</mat-label>
          <input matInput type="number" min="0" [(ngModel)]="invoiceGroupTemplate.SalaryCalculator.amount" name="salaryCalculatorHourlyAmount">
        </mat-form-field>
        <mat-form-field floatLabel="always" class="dialog-field calculator-number-field">
          <mat-label>Antal timmar</mat-label>
          <input matInput type="number" min="0" [(ngModel)]="invoiceGroupTemplate.SalaryCalculator.hours" name="salaryCalculatorHours">
        </mat-form-field>
      </div>
      <div class="calculator-base-amount" *ngIf="invoiceGroupTemplate.SalaryCalculator.salaryType === 'hourly'">
        <span>Grundbelopp (timbelopp × antal timmar)</span>
        <strong>{{ getSalaryCalculatorBaseAmount() | number:'1.2-2' }} kr</strong>
      </div>

      <mat-form-field floatLabel="always" class="dialog-field calculator-number-field" *ngIf="invoiceGroupTemplate.SalaryCalculator.salaryType === 'monthly' && invoiceGroupTemplate.SalaryCalculator.mode === 'gross'">
        <mat-label>Bruttolön (klumpsumma)</mat-label>
        <input matInput type="number" min="0" [(ngModel)]="invoiceGroupTemplate.SalaryCalculator.amount" name="salaryCalculatorLumpSumAmount">
      </mat-form-field>

      <section>
        <div class="calculator-setting-title">Pension</div>
        <div class="calculator-setting-description">Ange eventuell tjänstepensionsavsättning som procent av bruttolönen. Högsta tillåtna avsättning är 35 %.</div>
        <div class="pension-setting-row">
          <mat-form-field floatLabel="always" class="dialog-field calculator-number-field">
            <mat-label>Pension (procent av bruttolön)</mat-label>
            <input matInput type="number" min="0" max="35" [ngModel]="invoiceGroupTemplate.SalaryCalculator.pensionPercent" (ngModelChange)="onPensionPercentChanged($event)" name="salaryCalculatorPensionPercent"><span matSuffix>%</span>
          </mat-form-field>
        </div>
        <div class="calculator-setting-description pension-mode-description">Ange om pensionen ska dras från den angivna bruttolönen eller faktureras utöver bruttolönen.</div>
        <mat-radio-group class="employment-options" name="pensionMode" [(ngModel)]="invoiceGroupTemplate.SalaryCalculator.pensionMode">
          <mat-radio-button [value]="'deduct'">{{ invoiceGroupTemplate.SalaryCalculator.mode === 'invoice' ? 'Inkluderat i beloppet' : 'Inräknad i bruttolönen' }}</mat-radio-button>
          <mat-radio-button [value]="'add'" [disabled]="invoiceGroupTemplate.SalaryCalculator.mode === 'invoice'">Fakturera utöver bruttolönen</mat-radio-button>
        </mat-radio-group>
      </section>

      <section class="vacation-setting">
        <div class="calculator-setting-title">Semesterersättning 12 %</div>
        <div class="calculator-setting-description">Ange om semesterersättningen ska dras från den angivna bruttolönen eller faktureras utöver bruttolönen.</div>
        <mat-radio-group class="employment-options" name="vacationMode" [(ngModel)]="invoiceGroupTemplate.SalaryCalculator.vacationMode">
          <mat-radio-button [value]="'included'">{{ invoiceGroupTemplate.SalaryCalculator.mode === 'invoice' ? 'Inkluderat i beloppet' : 'Inräknad i bruttolönen' }}</mat-radio-button>
          <mat-radio-button [value]="'added'" [disabled]="invoiceGroupTemplate.SalaryCalculator.mode === 'invoice'">Fakturera utöver bruttolönen</mat-radio-button>
        </mat-radio-group>
      </section>
      </div>
    </div>
  </section>

  <div class="col-12 row dialog-row">
    <div class="calculator-amount-context" *ngIf="invoiceGroupTemplate.SalaryCalculator.mode === 'gross'">
      Semesterersättning: {{ invoiceGroupTemplate.SalaryCalculator.vacationMode === 'included' ? 'inräknad i bruttolönen' : 'faktureras utöver bruttolönen' }}<ng-container *ngIf="invoiceGroupTemplate.SalaryCalculator.pensionPercent > 0">. Pension: {{ invoiceGroupTemplate.SalaryCalculator.pensionMode === 'deduct' ? 'inräknad i bruttolönen' : 'faktureras utöver bruttolönen' }}</ng-container>. Gäller per ersättningsmottagare.
    </div>
    <div class="dialog-field-row">
      <div class="dialog-field-cell">
        <mat-form-field floatLabel="always" class="dialog-field calculator-number-field">
          <mat-label>{{ invoiceGroupTemplate.SalaryCalculator.mode === 'gross' ? 'Preliminärt underlag före arbetsgivaravgift' : 'Fakturerat belopp exkl. moms' }}</mat-label>
          <input type="number"
                 matInput
                 [ngModel]="invoiceGroupTemplate.SalaryCalculator.mode === 'gross' ? getPreliminarySalaryCalculatorAmount() : invoiceGroupTemplate.Amount"
                 (ngModelChange)="onInvoiceAmountChanged($event)"
                 [readonly]="invoiceGroupTemplate.SalaryCalculator.mode === 'gross'"
                 id="commission"
                 name="commission">
        </mat-form-field>
      </div>

      <div class="dialog-field-cell">
        <mat-form-field floatLabel="always" class="dialog-field">
          <mat-label>Moms</mat-label>
          <mat-select required [(ngModel)]="invoiceGroupTemplate.Vat" name="rowvatselected">
            <ng-container *ngFor="let item of vatList | slice:0:3">
              <mat-option value="{{item.Value}}">{{item.Value}} %</mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  </section>

  <div class="col-sm-12 sp-form-field dialog-actions">
    <button type="button" mat-stroked-button class="dialog-cancel-button" (click)="cancel()">Avbryt</button>
    <button type="submit" mat-raised-button class="dialog-save-button" [disabled]="!f.form.valid || !hasSelectedPaymentRecievers()" color="primary">Spara</button>
  </div>
</form>
